import { components, DropdownIndicatorProps } from "react-select";
import { BsSearch } from "react-icons/bs";

const DropdownIndicator = (props: DropdownIndicatorProps) => {
  return (
    <components.DropdownIndicator {...props}>
      <BsSearch color="gray" />
    </components.DropdownIndicator>
  );
};

export default DropdownIndicator;
